import { Controller } from "@hotwired/stimulus";

// NOTE:
// Controller pour la gestion des nested-forms has_many
// Fonctionne en version autosubmit ou pas
export default class extends Controller {
  static targets = ["links", "template"];
  static values = {
    autoSubmit: { type: Boolean, default: false },
    logic: { type: String, default: "beforeend" },
  };

  connect() {
    // Optional initialization
  }

  add_association(event) {
    event.preventDefault();

    // Create a unique ID for the new item
    const timestamp = new Date().getTime();

    // Clone the template content and replace the placeholder ID
    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      timestamp,
    );

    // Insert the new form fields into the DOM
    this.linksTarget.insertAdjacentHTML(this.logicValue, content);

    // Focus on the first input field of the newly added form
    const newForm =
      this.logicValue === "afterbegin"
        ? this.linksTarget.firstElementChild
        : this.linksTarget.lastElementChild;
    const firstInput = newForm.querySelector('input[type="text"]');
    if (firstInput) {
      firstInput.focus();
    }

    // If auto-submit is enabled, submit the form
    if (this.autoSubmitValue) {
      this.submitForm();
      newForm.remove(); // remove the fake input
    }
  }

  remove_association(event) {
    event.preventDefault();

    const wrapper = event.target.closest(".nested-fields");

    // Check if this is an existing record or new
    if (wrapper.querySelector("input[name*='[id]']")) {
      // Existing record - mark for destruction
      wrapper.querySelector("input[name*='[_destroy]']").value = 1;
      wrapper.style.display = "none";
    } else {
      // New record - just remove from DOM
      wrapper.remove();
    }
    // If auto-submit is enabled, submit the form
    if (this.autoSubmitValue) {
      this.submitForm();
    }
  }

  submitForm() {
    const form = this.element.closest("form");
    if (form) {
      // Add a subtle loading state to the form
      this.element.classList.add("opacity-75");

      // Use requestSubmit() if available (modern browsers), otherwise use submit()
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }
  }
}
